<template>
   <footer
      id="contacts"
      class="bg-primary -mt-(--footer-rounded-size) rounded-t-(--footer-rounded-size) h-[300px] text-white"
   >
      <div class="__container-landing pb-12 pt-8 sm:pt-14">
         <div class="flex justify-between gap-8 max-md:flex-col">
            <div>
               <h3 class="h-xl">{{ $t('web.components.footer.need-help') }}</h3>
               <p class="p-l">{{ $t('web.components.footer.help-description') }}</p>
            </div>

            <div class="flex gap-5 max-sm:flex-col sm:items-center sm:gap-8">
               <Stores />
               <NuxtLink :to="$localePath('/store-redirect')">
                  <Button large variant="secondary">{{ $t('common.download-app') }}</Button>
               </NuxtLink>
            </div>
         </div>

         <Separator class="mb-11 mt-8" />

         <div class="flex justify-between gap-8 max-sm:flex-col">
            <div class="flex gap-3 max-sm:flex-col sm:items-center sm:gap-7">
               <NuxtLink :to="$localePath('/')">
                  <Icon name="logotype-mono" class="h-[54px] w-[152px] text-white" />
               </NuxtLink>

               <NuxtLink to="https://home.provincia.bz.it/" target="_blank">
                  <Icon name="provinz" class="h-[47px] w-[185px] text-white" />
               </NuxtLink>
            </div>

            <div class="flex flex-col">
               <ul class="flex flex-col sm:text-right">
                  <li class="__clickable">
                     <NuxtLink :to="$localePath('/contact-us')">
                        {{ $t('web.components.footer.contact-us') }}
                     </NuxtLink>
                  </li>
                  <li class="__clickable">
                     <NuxtLink :to="$localePath('/faq')">
                        {{ $t('web.components.footer.faq') }}
                     </NuxtLink>
                  </li>
                  <li class="__clickable">
                     <NuxtLink :to="$localePath('/contact-us?type=error')">
                        {{ $t('web.components.footer.report') }}
                     </NuxtLink>
                  </li>
               </ul>
            </div>
         </div>

         <Separator class="mb-5 mt-11" />

         <div class="flex flex-col gap-8">
            <div class="flex justify-between">
               <HeaderLanguage inverted />
            </div>

            <div class="text-light-blue flex items-start justify-between gap-3 max-sm:flex-col">
               <p class="p-s">
                  Fischereiverband Südtirol | Unione Pesca Alto Adige<br />
                  Innsbrucker Straße 25 - 39100 Bozen | Via Innsbruck 25 - 39100 Bolzano<br />
                  VAT: IT03283050213
               </p>
               <div class="flex flex-col gap-3 sm:gap-2">
                  <ul class="p-s flex gap-1 max-sm:flex-col sm:items-center sm:gap-5">
                     <li class="__clickable">
                        <NuxtLink :to="$localePath('/legal/privacy')">
                           {{ $t('common.privacy-policy') }}
                        </NuxtLink>
                     </li>
                     <li class="__clickable">
                        <NuxtLink :to="$localePath('/legal/cookie')">
                           {{ $t('common.cookie') }}
                        </NuxtLink>
                     </li>
                     <li class="__clickable">
                        <NuxtLink :to="$localePath('/legal/tos')">
                           {{ $t('common.tos') }}
                        </NuxtLink>
                     </li>
                  </ul>
                  <p class="p-s sm:text-right">
                     Copyright © Südtirol Fishing {{ $dayjs().year() }}
                  </p>
                  <Attribution class="self-end" />
               </div>
            </div>
         </div>
      </div>
   </footer>
</template>

<script lang="ts" setup></script>
